import { gql } from '@apollo/client';

export interface Variables {
  programId: number;
}

export const QUERY = gql`
  query SeasonDeleteValidation($seasonId: Int!) {
    seasonDeleteValidation(seasonId: $seasonId) {
      isDeletable
      message
    }
  }
`;
